import { useEffect } from 'react';
import { useDrawerStore } from './useDrawerStore';

export const useCloseAllDrawersExpectMenu = () => {
  const onCloseAllDrawerExceptMenu = useDrawerStore((state) => state.onCloseAllDrawerExceptMenu);

  useEffect(() => {
    return () => onCloseAllDrawerExceptMenu();
  }, [onCloseAllDrawerExceptMenu]);
};
